import { useMutation } from '@tanstack/react-query';
import { MealPlanSummaryItem } from '@web-app/server/api/types';

const updateMealPlanSummary = async (
  payload: MealPlanSummaryItem,
): Promise<void> => {
  const res = await fetch('/api/meal-plan/update-meal-plan-summary', {
    method: 'PUT',
    body: JSON.stringify(payload),
  });

  if (!res.ok) {
    // soft fail.
    console.error(res);
  }

  return res.json();
};

export const useUpdateMealPlanSummary = () =>
  useMutation({
    mutationFn: (payload: MealPlanSummaryItem) =>
      updateMealPlanSummary(payload),
  });
